/**
 * /public/css/form.css
 */

import React from "react";

/**
 *
 * @param {*} props
 * className
 * error
 * fullWidth
 * onBlur
 * onChange
 * rows
 * small
 * trimOnBlur
 * asPassword
 * @returns
 */
export default function InputBase(props) {
    const refInput = React.useRef(null);
    const [type, setType] = React.useState(props?.asPassword ? "password" : "text");

    React.useEffect(() => {
        if (props.asPassword) {
            refInput.current.addEventListener("focus", onFocusBlur);
            refInput.current.addEventListener("blur", onFocusBlur);

            return () => {
                if (refInput?.current) {
                    refInput.current.removeEventListener("focus", onFocusBlur);
                    refInput.current.removeEventListener("blur", onFocusBlur);
                }
            };
        }
    }, []);

    function onFocusBlur(event) {
        setType(event.type === "focus" ? "text" : "password");
    }

    // Render component
    let Component = "input";

    // Combine component className
    const className = ["input-base"];

    // TODO! push
    Array.isArray(props.className) && className.push.call(className, props.className);
    typeof props.className === "string" && className.push(props.className);

    props.small && className.push("small");
    props.fullWidth && className.push("full-width");
    props.error && className.push("error");

    // Clean props
    const cleanProps = { ...props };
    delete cleanProps.small;
    delete cleanProps.fullWidth;
    delete cleanProps.trimOnBlur;
    delete cleanProps.asPassword;

    // Textarea
    if (props.rows) {
        Component = "textarea";
    }

    // Trim
    let onBlur = props.onBlur;
    if (props.trimOnBlur) {
        if (onBlur) {
            throw new Error(`props.onBlur conflicts with props.trimOnBlur`);
        }

        onBlur = function (event) {
            event.target.value = event.target.value.trim();
            (props.onBlur || props.onChange).apply(this, arguments);
        };
    }

    // if (type === "password" && props?.asPassword && cleanProps?.value) {
    //     cleanProps.value = cleanProps.value.replace(/./g, "*");
    // }

    return (
        <>
            <Component ref={refInput} type={type} onBlur={onBlur} {...cleanProps} className={className.join(" ")} />
            {props.error !== undefined && props.error !== null && (
                <div className="input-base-error">{props.error || <>&nbsp;</>}</div>
            )}
        </>
    );
}
